const getSections = () => {
    try {
        return require.context("components/config/dashboard-templates/Sections/", true, /\.json$/u);
    }
    catch {
        return null;
    }
};
const sections = getSections();
export const getInitialSections = () => sections?.keys().reduce((prev, curr) => {
    const section = sections(curr);
    prev[section.id] = section;
    return prev;
}, {}) ?? {};
export { getAvailableSectionIds, loadSection, loadSectionWithWidgetIds } from "./section-registry";
